import { motion } from "framer-motion";

/**
 * Reveal — scroll-triggered fade + translateY.
 * Respects prefers-reduced-motion via framer-motion's viewport handling.
 */
export const Reveal = ({ children, delay = 0, y = 24, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

/**
 * MaskedLines — line-by-line masked reveal for hero headlines.
 * Pass an array of strings; each renders inside an overflow-hidden mask.
 */
export const MaskedLines = ({ lines = [], className = "", lineClassName = "", start = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, delay: start + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export default Reveal;
